import { render, staticRenderFns } from "./successConfirm.vue?vue&type=template&id=b9fd4fea&scoped=true&"
import script from "./successConfirm.vue?vue&type=script&lang=js&"
export * from "./successConfirm.vue?vue&type=script&lang=js&"
import style0 from "./successConfirm.vue?vue&type=style&index=0&id=b9fd4fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd4fea",
  null
  
)

component.options.__file = "successConfirm.vue"
export default component.exports